export default __webpack_public_path__ + "static/media/heroMobile.2d245594.png";